module.exports = __webpack_public_path__ + "img/0Q3A7086_L_Black_MockedUp.b0273781.jpg";